<template lang="pug">
div
  .card.my-2.page-break
    .card-header
      .h5 {{ labelTotal }}
    .card-body.text-small
      table.table
        thead
          tr
            th {{ labelItems }}
            th.text-right Quantidade
        tbody
          tr(v-for="(coluna, index) in report.colunas")
            td.text-small
              | {{ coluna }}
              small.ml-2.label-rounded.label(v-for="tag in tags(coluna)" :class="mapTagClass[tag]") {{ tag }}
            td.text-right {{ totais[index] || 0 }}
          tr
            td.text-bold Total
            td.text-bold.text-right {{ somarTotal(totais) }}
  .card.my-2.page-break(v-for="(item, key) in report.data")
    .card-header
      .h5 {{ key }}
    .card-body.text-small
      table.table
        thead
          tr
            th {{ labelItems }}
            th.text-right Quantidade
        tbody
          tr(v-for="coluna in report.colunas")
            td.text-small
              | {{ coluna }}
              small.ml-2.label-rounded.label(v-for="tag in tags(coluna)" :class="mapTagClass[tag]") {{ tag }}
            td.text-right {{ item[coluna] || 0 }}
          tr
            td.text-bold Sub Total
            td.text-bold.text-right {{ somarTotal(item) }}
</template>

<script>
import { deepKey } from "paliari-js-utils"

export default {
  props: {
    report: { type: Object, required: true },
    labelItems: { type: String, required: true },
    labelTotal: { type: String, default: "Total" },
  },
  computed: {
    mapTagClass() {
      return {
        sábado: "label-warning",
        domingo: "label-error",
        feriado: "label-primary",
      }
    },
    totais() {
      if (!deepKey(this.report, "data") || !deepKey(this.report, "colunas")) {
        return []
      }
      const soma = {}
      Object.values(this.report.colunas).forEach(coluna => (soma[coluna] = 0))
      Object.values(this.report.data).forEach(data => {
        Object.keys(data).forEach(coluna => (soma[coluna] += data[coluna]))
      })

      return Object.values(soma)
    },
  },
  methods: {
    somarTotal(item) {
      const items = Object.values(item || {})

      return items.reduce((acc, item) => acc + item, 0)
    },
    tags(coluna) {
      if (!this.report || !this.report.tags) return []
      return this.report.tags[coluna] || []
    },
  },
}
</script>
